import { useSelector } from "react-redux";
import { useCallback, useMemo } from "react";
import compareVersions, { VERSION_CM_11155_ASSET_ROLES_VALIDATION } from "@cores/version";
import { isProd } from "@cores/enviromentExtension";

const UseCheckPermission = ({ scope, domain }) => {
    const stage = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);

    const myProjectPermissions = useSelector(({ roleManagementV2 }) => roleManagementV2?.projectPermissions?.data);
    const mySpacePermissions = useSelector(({ roleManagementV2 }) => roleManagementV2?.spacePermissions?.data);
    const isSpaceAdmin = useSelector(({ stage }) => stage?.user?.isSpaceAdmin);
    const isProjectAdmin = useSelector(({ stage }) => stage?.user?.projects.find((p) => p.id === project.id)?.isAdmin);

    const myPermissions = useMemo(
        () => (scope === "Project" ? myProjectPermissions : mySpacePermissions),
        [myProjectPermissions, mySpacePermissions],
    );

    const checkPermission = useCallback(
        (permission) => {
            if (
                (isProd && compareVersions(stage.version, VERSION_CM_11155_ASSET_ROLES_VALIDATION) < 0) ||
                !myPermissions
            )
                return true;
            if (isSpaceAdmin || isProjectAdmin) return true;
            if (!scope || !domain || !permission) return false;

            const requestedPermission = `${scope}:${domain}:${permission}`;

            return !!myPermissions.find(
                (p) => p.id === requestedPermission || p.includes.includes(requestedPermission),
            );
        },
        [myPermissions],
    );

    return [checkPermission];
};

export default UseCheckPermission;
